import { router } from 'expo-router';
import { useEffect } from 'react';
import { H5Regular, SafeAreaView, Spinner, YStack } from 'smoothie';

import { captureException } from '../../../logger/Logger';

const POST_CONNECTION_CONTINUATION_TIMEOUT = 10000; // 10 seconds to give Quiltt the chance to resolve cleanly, but not have the user wait too long

const QuilttOAuth = () => {
    useEffect(() => {
        let hangTightTimeout: number | undefined;

        const hopefullyContinue = () => {
            try {
                router.back();
            } catch (error) {
                captureException(
                    new Error(
                        'Quiltt OAuth Error: exception caught after connecting',
                    ),
                    { error },
                );
            }

            // This is just to handle the event that Quiltt takes too long calling back to the route after connecting accounts
            hangTightTimeout = window.setTimeout(() => {
                captureException(
                    new Error(
                        'Quiltt OAuth Timeout: post-connection callback timed out waiting for completion - navigating back.',
                    ),
                    {
                        note: 'Account connection success is unknown. Look up this connection attempt on the Quiltt dashboard for more info.',
                    },
                );
                if (router.canGoBack()) {
                    router.back();
                } else {
                    router.replace('/');
                }
            }, POST_CONNECTION_CONTINUATION_TIMEOUT);
        };

        hopefullyContinue();

        return () => {
            window.clearTimeout(hangTightTimeout);
        };
    }, []);

    return (
        <SafeAreaView style={{ flex: 1 }}>
            <YStack
                alignItems="center"
                justifyContent="center"
                gap={20}
                flex={1}
            >
                <H5Regular>Hang tight, we&apos;re taking you back</H5Regular>

                <Spinner />
            </YStack>
        </SafeAreaView>
    );
};

export default QuilttOAuth;
